import '../vendors/jquery-validate';
// import '../localization/messages_en';
// import '../localization/messages_fr';

class ContactForm {

    constructor() {
        this.init();
    }

    init() {
		this.participants();

		var contactFormIsValid = $('[contact-form]').validate({
			// rules: {
			// 	phone: {
			// 		phone: true
			// 	},
			// },
			ignore: ':hidden,:disabled,.ignore',
			errorElement: 'span',
			highlight: function (element) {
				return $(element).closest('.reg-form__group').find('label').addClass('error-label');
			},
			unhighlight: function (element) {
				return $(element).closest('.reg-form__group').find('label').removeClass('error-label');
			},
			errorPlacement: function (error, element) {
				error.wrap('<span class="error-tip"></span>').appendTo(element.closest('.reg-form__group').find('label'));
			}
		});
		var contactFormMobileIsValid = $('[contact-form-mobile]').validate({
			ignore: ':hidden,:disabled,.ignore',
			errorElement: 'span',
			highlight: function (element) {
				return $(element).closest('.reg-form__group').find('label').addClass('error-label');
			},
			unhighlight: function (element) {
				return $(element).closest('.reg-form__group').find('label').removeClass('error-label');
			},
			errorPlacement: function (error, element) {
				error.wrap('<span class="error-tip"></span>').appendTo(element.closest('.reg-form__group').find('label'));
			}
		});

		$(document).on('submit', '[contact-form], [contact-form-mobile]', function (e) {
			e.preventDefault();

			var isValid = $(this).hasClass('contact-form-mobile') ? contactFormMobileIsValid.valid() : contactFormIsValid.valid();

			if ( isValid ) {

				var submitBtn = $(this).find('button[type="submit"]');
				submitBtn.prop('disabled', true);

				var form = $(this).serializeArray();
				var dataToSend = [];

				$(form).each(function (index, el) {
					dataToSend[el.name] = el.value;

				});

				var data = {
					'action': 'custom_form_proceed',
					'town': dataToSend['town'],
					'city': dataToSend['city'],
					'maths': dataToSend['maths'],
					'form_name': dataToSend['form_name'],
					'_wpnonce': dataToSend['_wpnonce'],
					'firstname': dataToSend['firstname'],
					'lastname': dataToSend['lastname'],
					'company': dataToSend['company'],
					'email': dataToSend['email'],
					'count': dataToSend['count'],
					'participant_firstname_1' : dataToSend['participant_contact_firstname_1'],
					'participant_lastname_1' : dataToSend['participant_contact_lastname_1'],
					'participant_firstname_2' : dataToSend['participant_contact_firstname_2'],
					'participant_lastname_2' : dataToSend['participant_contact_lastname_2'],
					'cocktail': dataToSend['cocktail'],
					'_wp_http_referer': dataToSend['_wp_http_referer'],
				}

				$.ajax({
					url: ajaxurl,
					data: data,
					type: 'POST',
					success: function (data) {

						if (data.success){

							if(window.innerWidth >767)
								var contactForm = document.getElementById('reg-form');
							else
								var contactForm = document.getElementById('reg-form-mobile');
							contactForm.classList.add('is-sent');

							if(window.innerWidth < 768 && $("#thanks-msg-mobile").length ){

								$('html, body').animate({
									scrollTop: $("#thanks-msg-mobile").offset().top - 125
								}, 300);

							}
						}

					}
				})

			} else {

			}

		});
    }

	participants(){
    	let participants = $('[participants]');

		$('#contact_count, #contact_count_mobile').on('change', (e)=>{

			if( +e.currentTarget.value > 1 ){

				switch(+e.currentTarget.value){
					case 2:
						$('[participant-1]').show();
						$('[participant-2]').slideUp();
						setTimeout(()=>{participants.slideDown()}, 400);
						break;
					case 3:
						$('[participant-1]').slideDown();
						$('[participant-2]').slideDown();
						setTimeout(()=>{participants.slideDown()}, 400);
						break;
				}


			}else{
				participants.slideUp();
				setTimeout(()=>{
					$('[participant-1]').slideUp();
					$('[participant-2]').slideUp();
				}, 400);
			}
		});
	}

}

export default ContactForm;



// WEBPACK FOOTER //
// ./scripts/modules/contact-form.js